// extracted by mini-css-extract-plugin
module.exports = {"page-header":"index_page-header__182XT","breadcrumb":"index_breadcrumb__7ZxW9","header-title":"index_header-title__2OoH4"};